// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--wvpRY","dark":"_93444fe79c--dark--HdtBl"};